/**
 * Does this browser need us to paint a PDF, or can an <iframe> do it?
 *
 * Phones cannot. Android Chrome has no in-page PDF viewer at all — a PDF in an
 * iframe is a blank frame — and iOS Safari paints only the first page, as an
 * image the frame will not scroll. So on a phone a shared PDF was a blank or
 * cut-off box. `pdfViewerEnabled` is the standard answer to "can this browser
 * show a PDF inline"; a coarse pointer catches the iPad, which says yes and
 * still shows one unscrollable page.
 */
export function needsPaintedPdf(): boolean {
  if (typeof navigator === "undefined") return false;
  if (navigator.pdfViewerEnabled === false) return true;
  return typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches;
}
